module.exports = __webpack_public_path__ + "media/live-hero.70a21f30.mp4";